import React, { useContext, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { createCookie, readCookie, redirectToPMSAndExistPlanPage } from "../../Util/helper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import UserService from "../../Services/UserService";
import { UserActionEnum } from "../../Config/UserType";
import { ProcessLogout } from "../../Util/Process-Logout";
import { ROUTE_CONSTANT } from "../../Util/Constants";
import UserDataContext from "../../Contexts/User.context";
import { formActionEnum } from "../../Config/Constants";
import { isPaymentMSEnable } from "../../Util/general-config";

const SsoTransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { locale } = useParams();
  const { state, dispatch } = useContext(UserDataContext);
  //   const setLocaleURL = (url: string) => {
  //     let verifiedLocale = "en";
  //     if (!!locale) {
  //       if (availableLanguages.indexOf(locale) > -1) {
  //         verifiedLocale = locale;
  //       }
  //     }
  //     return url.replace(":locale", verifiedLocale);
  //   };
  const NavigateRoute = (target: string) => {
    let targetIncludes: string | undefined = "";
    let targetParams =
      decodeURIComponent(target).indexOf("?") > -1 ? "?" + decodeURIComponent(target).split("?").pop() : "";
    if (targetParams.includes("docid") || targetParams.includes("q")) {
      window.location.assign(decodeURIComponent(target));
    } else {
      targetIncludes = !!target && target.split("/").length > 0 ? target.split("/").pop() : "";
    }
    if (!!targetIncludes && targetIncludes.includes("plans") === true) {
      let isNavigateToExistingPlanPage = redirectToPMSAndExistPlanPage();
      if (isNavigateToExistingPlanPage) {
        navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
      }
    } else if (!!targetIncludes && targetIncludes.includes("dashboard")) {
      //external href/redirect to dashboard as it is not a component.
      window.location.assign(decodeURIComponent(target));
    } else {
      if (!targetParams) {
        window.location.assign(decodeURIComponent(target));
      } else {
        navigate(ROUTE_CONSTANT.HOME + targetParams);
      }
    }
  };
  useEffect(() => {
    const jwtToken = new URLSearchParams(location.search).get("jtkn");
    const legacyTicket = new URLSearchParams(location.search).get("lgct");
    const target = new URLSearchParams(location.search).get("tgt");
    if (!!jwtToken) {
      createCookie("jwtToken", jwtToken, 1);
    }
    if (!!legacyTicket) {
      createCookie("legacyTicket", decodeURIComponent(legacyTicket), 1);
    }
    if (!!jwtToken) {
      UserService.getUserObject().then((response: any) => {
        if (!!response) {
          let userGuid = response.userGuid;
          let email = response.email;
          var validUserGuid = userGuid;
          if (userGuid.includes("-") == false) {
            validUserGuid = userGuid.replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, "$1-$2-$3-$4-$5");
          }
          let parentUserGuid = response.parentUserGuid;
          dispatch({
            type: UserActionEnum.SET_USERINFO,
            payload: { userGUID: validUserGuid, email: email },
          });
          createCookie("jwtToken", jwtToken, 1);
          createCookie("ssoToken", jwtToken, 1);
          createCookie("ssoauth", "1");
          if (!!target) {
            NavigateRoute(target);
          }
        }
      });
    } else {
      if (!!target) {
        NavigateRoute(target);
      }
    }
  }, []);
  return (
    <div>
      <div className="displaymobile">
        <img
          className="legalsimpli-logo height-37 mt-3 mb-3 ps-20"
          src={process.env.PUBLIC_URL + "/static/images/legalsimpli-logov2.svg"}
          alt="PDFsimpli"
          draggable="false"
        />
      </div>
      <section className="section main-content text-center">
        <div className="container intro">
          <div className="row">
            <div className="col-12 headline-group">
              <hgroup>
                <h2>Please wait...</h2>
              </hgroup>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SsoTransfer;
